import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationFR from './locales/fr.json';
import translationEN from './locales/en.json';
import translationDE from './locales/de.json';

const resources = {
   fr: { translation: translationFR },
   en: { translation: translationEN },
   de: { translation: translationDE },
};

i18n
   .use(LanguageDetector)
   .use(initReactI18next)
   .init({
      resources,
      fallbackLng: 'fr',
      interpolation: {
         escapeValue: false,
      },
      detection: {
         order: ['localStorage', 'navigator'],
         caches: ['localStorage'],
      },
   });

export default i18n;
